import React from 'react';
import './toggleWithLabel.css';

interface ToggleWithLabelProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ToggleWithLabel: React.FC<ToggleWithLabelProps> = ({ label, checked, onChange }) => {
  return (
    <div className="toggle-with-label">
      <label className="if-switch-toggle">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="if-slider-toggle" />
      </label>
      <span className="toggle-label">{label}</span>
      <div className="toggle-divider" />
    </div>
  );
};

export default ToggleWithLabel;